// Brand Purple Color System
export const BRAND_PURPLE = '#6e28cc';

// Heading Color
export const HEADING_COLOR = '#1e40af'; // blue-800

// Purple color variations
export const PURPLE_COLORS = {
  primary: BRAND_PURPLE,
  hover: '#5a1fb8', // Slightly darker for hover states
  light: '#f3f0ff', // Very light background
  lighter: '#e6e0ff', // Light background
  medium: '#b794f6', // Medium purple for borders
  dark: '#553c9a', // Darker purple for text
};

// Solid color replacements (no gradients)
export const COLORS = {
  purple: BRAND_PURPLE,
  purpleHover: PURPLE_COLORS.hover,
  purpleLight: PURPLE_COLORS.light,
  purpleLighter: PURPLE_COLORS.lighter,
  purpleMedium: PURPLE_COLORS.medium,
  purpleDark: PURPLE_COLORS.dark,
  headingColor: HEADING_COLOR,
  
  // Other colors that work well with purple
  pink: '#ec4899',
  blue: '#3b82f6',
  indigo: '#6366f1',
};

// CSS custom properties for global usage
export const CSS_VARIABLES = `
  :root {
    --brand-purple: ${BRAND_PURPLE};
    --purple-hover: ${PURPLE_COLORS.hover};
    --purple-light: ${PURPLE_COLORS.light};
    --purple-lighter: ${PURPLE_COLORS.lighter};
    --purple-medium: ${PURPLE_COLORS.medium};
    --purple-dark: ${PURPLE_COLORS.dark};
    --heading-color: ${HEADING_COLOR};
  }
`;